export default __webpack_public_path__ + "static/media/vouchers--roi@2x.63abd544.png";